module.exports = __webpack_public_path__ + "img/wardInfoBlack.39935d1e.svg";